import { useQuery } from "@tanstack/react-query";
import { IFeedbackApi } from "@/api/feedback";
import { SERVICES_TYPES, useInjection } from "@/ioc";

export const useFeedback = () => {
  const feedbackApi = useInjection<IFeedbackApi>(SERVICES_TYPES.FEEDBACK);

  return useQuery({
    queryKey: ["feedback"],
    queryFn: () => feedbackApi.getAll(),
  });
};
